import { Theme } from "@pga/pga-component-library"

export const PTM_APPLICATION_TYPES = {
  ASSOCIATE: "associate",
  AFFILIATE: "affiliate",
}

const STATUS_DISPLAY = {
  submitted: { text: "Submitted", color: Theme.colors.lightBlue },
  under_review: { text: "Under Review", color: Theme.colors.orange },
  changes_requested: { text: "Under Review", color: Theme.colors.orange },
  approved: { text: "Approved", color: Theme.colors.successGreen },
  denied: { text: "Declined", color: Theme.colors.maroon },
}

const APPLY_CTA_LABELS = {
  [PTM_APPLICATION_TYPES.ASSOCIATE]: {
    awaiting: "Awaiting Requirements",
    resume: "Resume Associate",
    reapply: "Reapply Associate",
    apply: "Become Associate",
  },
  [PTM_APPLICATION_TYPES.AFFILIATE]: {
    awaiting: "Awaiting Requirements",
    resume: "Resume Affiliate",
    reapply: "Reapply Affiliate",
    apply: "Become Affiliate",
  },
}

// Statuses that replace the Become CTA. Denied and closed registration keep
// apply so prospects can re-apply.
const CTA_REPLACING_STATUSES = new Set([
  "submitted",
  "under_review",
  "changes_requested",
  "approved",
])

export const isClosedRegistrationPtmApplication = (
  status,
  registrationStatus,
) =>
  String(status || "").toLowerCase() === "approved" &&
  String(registrationStatus || "").toLowerCase() === "closed"

export const shouldReplaceApplyCtaWithStatus = (status, registrationStatus) => {
  if (!status) return false
  if (isClosedRegistrationPtmApplication(status, registrationStatus)) {
    return false
  }
  return CTA_REPLACING_STATUSES.has(String(status).toLowerCase())
}

export const isDeniedPtmApplication = status =>
  String(status || "").toLowerCase() === "denied"

export const isDraftPtmApplication = status =>
  String(status || "").toLowerCase() === "draft"

export const ptmApplyCtaLabel = ({
  applicationType,
  requirementsMet = true,
  isResume = false,
  isClosedRegistration = false,
}) => {
  const labels =
    APPLY_CTA_LABELS[String(applicationType || "").toLowerCase()] ||
    APPLY_CTA_LABELS[PTM_APPLICATION_TYPES.ASSOCIATE]
  if (!requirementsMet) return labels.awaiting
  if (isResume) return labels.resume
  if (isClosedRegistration) return labels.reapply
  return labels.apply
}

export const mapPtmApplicationStatus = (status, registrationStatus) => {
  if (isClosedRegistrationPtmApplication(status, registrationStatus)) {
    return null
  }
  if (!status) return null
  return STATUS_DISPLAY[String(status).toLowerCase()] || null
}

export const pickLatestApplicationForType = (applications, applicationType) => {
  if (!Array.isArray(applications) || !applicationType) return null

  const matches = applications.filter(
    app =>
      app?.applicationType &&
      String(app.applicationType).toLowerCase() ===
        String(applicationType).toLowerCase(),
  )

  if (matches.length === 0) return null

  return matches.reduce((latest, app) => {
    if (!latest) return app
    const latestUpdated = Date.parse(latest.updatedAt || 0) || 0
    const appUpdated = Date.parse(app.updatedAt || 0) || 0
    return appUpdated > latestUpdated ? app : latest
  }, null)
}
